import {BaselineValue} from './BaselineValue';
import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class Baseline extends BasicEntity {
bink: string;
cascadeDeep: number | null;
child: string[];
chron: string;
deleteCascade: boolean | null;
fake: boolean | null;
fkeyjson: Object;
key: string;
level: number | null;
pkey: string;
scen: string;
series: {[key: string]: string};
splittedKey: string[];
trios: {[key: string]: string};
updateCascade: boolean | null;
updateCascadeKey: string[];
v: string;
values: {[key: string]: BaselineValue};
vs: string;
vsp: string;
}

